import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { margin, width } from 'styled-system';
import gsap from 'gsap';

import useTranslation from 'hooks/use-translation';

import ChevronIcon from 'assets/marketing/chevron-icon';
import CtaBlock from '../cta-block';
// import Dots from '../dots';
import SectionLabel from '../section-label';
import Stacked from '../stacked';

export default function StackedSlider(props) {
  const { content, layers } = props;
  const { t } = useTranslation();
  const [direction, setDirection] = useState(null);
  const [animationLayer, setAnimationLayer] = useState(-1);
  const [contentLayer, setContentLayer] = useState(0);
  const { label } = content?.[contentLayer];
  const contentRef = useRef();
  // useEffect(() => {
  //   gsap.fromTo(contentRef.current, { opacity: 0 }, { opacity: `100%`, duration: 1.5 });
  // }, [contentLayer]);
  const handleOnChange = (count, newDirection) => {
    if (count < 0 || count >= content.length) {
      return;
    }
    if (count === content.length - 1) {
      setAnimationLayer(content.length - 1);
      setDirection(`down`);
    }
    if (animationLayer === -1) {
      setAnimationLayer(-1);
      setDirection(`up`);
    }
    setContentLayer(count);
    setAnimationLayer(contentLayer);
    setDirection(newDirection);
  };

  return (
    <Container className='pinned'>
      <Column width='40%' margin='60px 0 0 0' noMobileMargin>
        <Content>
          {/* TODO: readding after release to get scroll animation hooked up */}
          {/* <DotContainer>
            <Dots count={3} activeIndex={contentLayer} />
          </DotContainer> */}
          <Buttons>
            <ButtonContainer onClick={() => handleOnChange(contentLayer - 1, `down`)}>
              <ChevronIcon />
            </ButtonContainer>
            <ButtonContainer onClick={() => handleOnChange(contentLayer + 1, `up`)} whiteBg>
              <ChevronIcon />
            </ButtonContainer>
          </Buttons>
          <div ref={contentRef}>
            <CtaBlock
              {...content?.[contentLayer]}
              label={<SectionLabel section='01' label={label} />}
              cta={null}
              route='https://docs.dutchie.com/dutchie-plus/'
              margin='0 40px 24px 0'
            />
          </div>
        </Content>
      </Column>
      <Column width='60%' height='250px' margin='0 0 0 60px' mobileMargin='0 0 125px 0' padding='0'>
        <Stacked direction={direction} onChange={setContentLayer} animationLayer={animationLayer}>
          {layers}
        </Stacked>
      </Column>
    </Container>
  );
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  ${width};
  ${margin};
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    width: 100%;
    padding: 0 40px 0 0;
    ${({ height }) => height && `height: ${height}`};
    ${({ padding }) => padding && `padding: ${padding}`};
    ${({ mobileMargin }) => mobileMargin && `margin: ${mobileMargin}`};
    ${({ noMobileMargin }) => noMobileMargin && `margin: 0`};
    max-width: 400px;
  }
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex: 1 1 auto;
  color: ${({ theme }) => theme.colors.white};
  margin: 0 auto;
  max-width: 1440px;
  place-items: center;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    flex-direction: column-reverse;
    &.pinned {
      /* top: 0 !important; */
      height: auto !important;
    }
  }
`;

const Buttons = styled.div`
  position: absolute;
  left: -80px;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    right: -20px;
    left: unset;
  }
`;

const ButtonContainer = styled.div`
  height: 40px;
  width: 40px;
  border: 1px solid white;
  border-radius: 100px;
  display: flex;
  place-items: center;
  place-content: center;
  margin-bottom: 15px;
  background: ${({ theme, whiteBg }) => (whiteBg ? theme.colors.white : `transparent`)};
  cursor: pointer;
  &:nth-child(1) {
    svg {
      margin-top: 0;
      transform: rotate(180deg);
    }
  }
  svg {
    margin-top: 2px;
    height: 16px;
    width: 16px;
    fill: ${({ theme, whiteBg }) => (whiteBg ? theme.colors.dutchiePlusBlue[10] : theme.colors.white)};
  }
`;

const Content = styled.div`
  max-width: 466px;
  width: 100%;
  margin: 0 auto;
  padding-top: 120px;
  position: relative;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding: 0;
    height: 500px;
    max-width: 325px;
  }
`;
